import { Failure } from '../../core/domain/error/failures';

export class SendMessageFailure extends Failure {
  constructor(error: any) {
    super('Send message failure', error);
  }
}
